import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import CssBaseline from '@mui/material/CssBaseline';
import Home from './Home';

const theme = createTheme({
  typography: {
    fontFamily: 'Open Sans',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 900,
      md: 1280,
      lg: 1920,
      xl: 3200
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        p: {
          margin: '0px',          
          padding: '0px'          
        }
      }     
    },
  }
});
/*
let theme = createTheme({
  typography: {
    fontFamily: 'Open Sans',
    h1: { fontSize: '5rem' },    
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 425,
      md: 768,
      lg: 1024,
      xl: 1280,
      '2xl': 1536,
      '3xl': 1920,
      '4xl': 2560,
      '5xl': 3200,
    },
  },  
})

theme = responsiveFontSizes(theme, { breakpoints: ['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl'], factor: 10 });
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Home />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
